import {
  Avatar,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Input,
  Option,
  Select,
  Textarea,
  Tooltip,
  Typography,
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import {getProvinces} from "../../services/province/province";
import {getPersonProfile, updatePersonProfile} from "../../services/profile/profile";
import SelectInput from "../system/select";
import {getProvinceCities} from "../../services/city/city";
import WalletReservation from "../system/walletReservation";
import Validator from "../../helper/validator/Validator";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import DateField from "../system/dateField";
import {Toaster} from "../../helper/Toaster";
import {ProfilePhoto} from "./change_profile_photo";
import {getFileUrl} from "../../config";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {checkAll} from "../../helper/validator/Check";
import {toast} from "react-toastify";


export function Profile() {

  const avatar = '/assets/blank_profile.jpg';

  const [personProfile, setPersonProfile] = useState({})

  const [id, setId] = useState(null)
  const [personDataId, setPersonDataId] = useState(null)
  const [name, setName] = useState("")
  const [family, setFamily] = useState("")
  const [roleTitle, setRoleTitle] = useState("")
  const [phone, setPhone] = useState("")
  const [photo, setPhoto] = useState("")

  const [fatherName, setFatherName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  // const [province, setProvince] = useState("");
  const [provinceId, setProvinceId] = useState(personProfile?.province_id ?? null);
  // const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [homePhone, setHomePhone] = useState("")
  const [email, setEmail] = useState("")
  const [address, setAddress] = useState("")
  const [loaded, setLoaded] = useState(false)
  const [modalOpen, setModalOpen] = useState(false);
  const [lastDataRefresh, setLastDataRefresh] = useState(null)

  const [reserves, setReserves] = useState(null)

  const [nameExist, setNameExist] = useState(false);
  const [familyExist, setFamilyExist] = useState(false);
  const [fatherNameExist, setFatherNameExist] = useState(false);
  const [nationalCodeExist, setNationalCodeExist] = useState(false);
  const [birthDateExist, setBirthDateExist] = useState(false);
  const [genderExist, setGenderExist] = useState(false);

  useEffect(() => {
    async function getData() {
      const result = await getPersonProfile();
      if (result.status === 200) {
        const {person_profile, wallet_reservation_log} = result.data;
        setPersonProfile(person_profile)
        setReserves(wallet_reservation_log || [])
        setLoaded(true)
      }
    }

    getData()
  }, [])


  useEffect(() => {
    setPersonProfile(personProfile || {})
    setId(personProfile?.id ?? null);
    setPersonDataId(personProfile?.person_data_id ?? null);
    setPhone(personProfile?.phone ?? "");
    setName(personProfile?.name ?? "");
    setNameExist((personProfile?.name?.length ?? 0) > 0);
    setFamily(personProfile?.family ?? "");
    setFamilyExist((personProfile?.family?.length ?? 0) > 0);
    setPhoto(personProfile?.photo ?? "");
    setFatherName(personProfile?.father_name ?? "");
    setFatherNameExist((personProfile?.father_name?.length ?? 0) > 0);
    setNationalCode(personProfile?.national_code ?? "");
    setNationalCodeExist((personProfile?.national_code?.length ?? 0) > 0);
    setBirthDate(personProfile?.birth_date ?? "");
    setBirthDateExist((personProfile?.birth_date?.length ?? 0) > 0);
    setGender(personProfile?.gender ?? "");
    setGenderExist(personProfile?.gender === "male" || personProfile?.gender === "female");
    setHomePhone(personProfile?.home_phone ?? "");
    setProvinceId(personProfile?.province_id ?? null);
    setCityId(personProfile?.city_id ?? null);
    setEmail(personProfile?.email ?? "");
    setAddress(personProfile?.address ?? "");
    setRoleTitle(personProfile?.role_title ?? "");
  }, [personProfile]);

  const save = async () => {
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
      return
    }
    const data = {
      id: id,
      phone: phone,
      name: name,
      family: family,
      photo: photo,
      father_name: fatherName,
      national_code: nationalCode,
      birth_date: birthDate,
      // gender: gender,
      home_phone: homePhone,
      province_id: parseInt(provinceId),
      city_id: parseInt(cityId),
      email: email,
      address: address,
    };
    if (personDataId !== 0) {
      data.person_data_id = personDataId;
    }
    if (gender === "male" || gender === "female") {
      data.gender = gender
    }

    let result;
    result = await updatePersonProfile(data)
    if (result.status === 200) {
      const {person_profile} = result.data;
      setPersonProfile(person_profile)
    }
  };


  return (
    <>
      {modalOpen &&
        <ProfilePhoto
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          src={getFileUrl(photo)}
          setPhoto={setPhoto}/>
      }
      {loaded &&
        <ValidatorProvider>
          <div className="flex flex-col md:flex-row gap-8">

            <div className="flex flex-col w-full md:w-2/5 gap-y-8">
              <div className="flex">

                <Card className="w-full">
                  <div className="flex justify-around">
                    <Avatar variant="circular" alt="tania andrew"
                            className="cursor-pointer absolute mt-16 border-white z-10"
                            withBorder={true} size="xxl"
                            src={photo ? getFileUrl(photo) : avatar}
                            onClick={() => (setModalOpen(!modalOpen))}
                    />
                    <img 
                      src="/assets/pattern.webp"
                      className="max-h-32 w-full rounded-t-2xl opacity-80"
                    ></img>
                  </div>

                  <CardBody className="text-center mt-16 border-b border-spacing-x-px">
                    <Typography variant="h4" color="blue-gray" className="mb-2">
                      {name + " " + family}
                    </Typography>
                    <Typography className="font-medium text-blue-gray-600">
                      {Dict(roleTitle)}
                    </Typography>
                    <Typography className="font-medium text-blue-gray-500 mt-4">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </CardBody>
                  <CardFooter className="flex justify-center gap-7 pt-2">
                    <Tooltip content="Like">
                      <Typography
                        as="a"
                        href="#facebook"
                        variant="lead"
                        color="blue"
                        textGradient
                      >
                        <i className="fab fa-facebook"/>
                      </Typography>
                    </Tooltip>
                    <Tooltip content="Follow">
                      <Typography
                        as="a"
                        href="#twitter"
                        variant="lead"
                        color="light-blue"
                        textGradient
                      >
                        <i className="fab fa-twitter"/>
                      </Typography>
                    </Tooltip>
                    <Tooltip content="Follow">
                      <Typography
                        as="a"
                        href="#instagram"
                        variant="lead"
                        color="purple"
                        textGradient
                      >
                        <i className="fab fa-instagram"/>
                      </Typography>
                    </Tooltip>
                  </CardFooter>
                </Card>

              </div>

              <div className="flex">


                <Card className="w-full mt-8">
                  <CardHeader className="bg-gray-800">
                    <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
                      سرویس‌های من
                    </Typography>
                  </CardHeader>
                  <CardBody>
                    <div className="mb-4">
                      <WalletReservation reserves={reserves}/>
                    </ div>
                  </CardBody>
                </Card>

              </div>
            </div>

            <div className="flex flex-col w-full md:w-3/5 gap-y-8 pt-6">
              <Card>
                <CardHeader className="bg-gray-800">
                  <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
                    ویرایش اطلاعات
                  </Typography>
                  {/*<img src="/assets/pattern.webp"*/}
                  {/*     className="max-h-32 w-full rounded-t-2xl opacity-80 bg-gray-900"*/}
                  {/*></img>*/}
                </CardHeader>
                <CardBody>

                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">

                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={name}
                             label={Dict('name')}
                             placeholder={Dict('name')}
                             onChange={(e) => {
                               if (!nameExist) {
                                 setName(e.target.value)
                               } else {
                                 toast.error("امکان ویرایش اطلاعات هویتی وجود ندارد.")
                               }
                             }}
                      />
                      <Validator state={name} rules="required|alphabetic"/>
                    </div>


                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={family}
                             label={Dict('family')}
                             placeholder={Dict('family')}
                             onChange={(e) => {
                               if (!familyExist) {
                                 setFamily(e.target.value)
                               } else {
                                 toast.error("امکان ویرایش اطلاعات هویتی وجود ندارد.")
                               }
                             }}
                      />
                      <Validator state={family} rules="required|alphabetic"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={nationalCode}
                             label={Dict('national_code')}
                             placeholder={Dict('national_code')}
                             onChange={(e) => {
                               if (!nationalCodeExist) {
                                 setNationalCode(e.target.value)
                               } else {
                                 toast.error("امکان ویرایش اطلاعات هویتی وجود ندارد.")
                               }
                             }}
                      />
                      <Validator state={nationalCode} rules="required|num|len=10"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={fatherName}
                             label={Dict('father_name')}
                             placeholder={Dict('father_name')}
                             onChange={(e) => {
                               if (!fatherNameExist) {
                                 setFatherName(e.target.value)
                               } else {
                                 toast.error("امکان ویرایش اطلاعات هویتی وجود ندارد.")
                               }
                             }}
                      />
                      <Validator state={fatherName} rules="required|alphabetic"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      {!birthDateExist ?
                        <DateField
                          className="my-4 mx-4 w-full"
                          date={birthDate}
                          setDate={setBirthDate}
                          label={Dict("birth_date")}
                        />
                        :
                        <Input variant="standard"
                               value={persianNumberFormat(birthDate).replaceAll('-', '/')}
                               label={Dict('birth_date')}
                        />
                      }

                      <Validator state={birthDate} rules="required"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <Select variant="static" className="rtl" style={{label: {left: ""}}}
                              label={Dict('gender')}
                              value={gender}
                              disabled={genderExist}
                              onChange={(val) => {
                                setGender(val)
                      }}>
                        <Option value="male">مرد</Option>
                        <Option value="female">زن</Option>
                      </Select>
                      <Validator state={gender} rules="required"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={homePhone}
                             label={Dict('home_phone')}
                             placeholder={Dict('home_phone')}
                             onChange={(e) => {
                               setHomePhone(e.target.value)
                             }}
                      />
                      <Validator state={homePhone} rules="required|phoneNumber"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <Input variant="standard"
                             value={email}
                             label={Dict('email')}
                             placeholder={Dict('email')}
                             onChange={(e) => {
                               setEmail(e.target.value)
                             }}
                      />
                      <Validator state={email} rules="required|email"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <SelectInput
                        className="w-full"
                        label={Dict("province")}
                        defaultValue={provinceId}
                        autoLoadService={getProvinces}
                        onChange={setProvinceId}
                      />
                      <Validator state={provinceId} rules="required"/>
                    </div>

                    <div className="flex flex-col w-full mb-4">
                      <SelectInput
                        className="w-full"
                        label={Dict("city")}
                        defaultValue={cityId}
                        refreshSignal={provinceId}
                        autoLoadService={getProvinceCities}
                        autoLoadServiceData={provinceId}
                        onChange={setCityId}
                      />
                      <Validator state={cityId} rules="required"/>
                    </div>

                  </div>

                  <div className="grid grid-cols-1 gap-6 xxl:grid-cols-3">

                    <Textarea
                      variant="standard"
                      value={address}
                      label={Dict('address')}
                      onChange={(e) => {
                        setAddress(e.target.value)
                      }}
                    />
                    <Validator state={address} rules="required"/>

                  </div>


                </CardBody>
                <CardFooter>
                  <Button variant="gradient" color="gray" onClick={save} className="ml-1">
                    <span>ذخیره</span>
                  </Button>
                </CardFooter>
              </Card>

            </div>

          </div>
        </ValidatorProvider>
      }
    </>
  );
}
